import React, { Component } from "react";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { AlertModalBody } from "styled_components/Common/AlertModalBody";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { CompanyProfileApi } from "services/companyProfile";
import { RESOLUTIONS } from "services/config";
import { getCurrentMembership } from "services/companyProfile";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const closeButton = `${CDN_URL}common/modal-x-button-default-lg.svg`;
const closeHover = `${CDN_URL}common/modal-X-button-hover.svg`;

class AlertBanner extends Component {
  constructor(props) {
    super(props);
    this.companyApi = new CompanyProfileApi();
    this.state = {
      showModal: false,
      enabled: false,
      alerts: null,
    };
  }

  componentDidMount() {
    const membership = getCurrentMembership();
    // const enabled = sessionStorage.getItem('showAlert');
    // this.setState({ enabled });

    if (membership?.beta) {
      this.alertInterval = setInterval(() => {
        this.checkForAlert();
      }, 900 * 1000);
      this.checkForAlert();
    }
  }
  componentWillUnmount() {
    clearInterval(this.alertInterval);
  }

  checkForAlert = () => {
    // const { alerts } = this.state;
    // const { orgId } = this.props;
    // TicketApi.getAlerts(orgId)
    //   .then((response) => {
    //     const validResponse =
    //       response.status === 200 && response.data && response.data[0];
    //     if (validResponse) {
    //       if (alerts && Utils.isEqual(alerts, response?.data)) {
    //       } else {
    //         const showModal = sessionStorage.getItem("showAlert");
    //         this.setState(
    //           {
    //             alerts: response?.data,
    //             enabled: showModal === "false" ? false : true,
    //           },
    //           () => {
    //             this.changeFeedbackPosition();
    //           }
    //         );
    //       }
    //     } else {
    //       this.setState(
    //         { error: "Error checking for alert", enabled: false },
    //         () => {
    //           this.changeFeedbackPosition();
    //         }
    //       );
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({ error, enabled: false }, () => {
    //       this.changeFeedbackPosition();
    //     });
    //   });
  };

  changeFeedbackPosition = () => {
    const feedbackImage = document.getElementById("feedback-image");
    const feedbackImageHome = document.getElementById("feedback-image-home");
    const infoImage = document.getElementById("information-image");
    const infoImageHome = document.getElementById("information-image-home");
    const startTour = document.getElementById("start-tour-container");
    const mainContent = document.getElementById("main-content");
    const startTourPortal = document.getElementById(
      "start-tour-container-portal"
    );
    const { enabled } = this.state;
    if (feedbackImage) {
      enabled
        ? feedbackImage.classList.add("alert-present")
        : feedbackImage.classList.remove("alert-present");
    }
    if (feedbackImageHome) {
      enabled
        ? feedbackImageHome.classList.add("alert-present")
        : feedbackImageHome.classList.remove("alert-present");
    }
    if (startTour) {
      enabled
        ? startTour.classList.add("alert-present")
        : startTour.classList.remove("alert-present");
    }
    if (startTourPortal) {
      enabled
        ? startTourPortal.classList.add("alert-present")
        : startTourPortal.classList.remove("alert-present");
    }
    if (infoImage) {
      enabled
        ? infoImage.classList.add("alert-present")
        : infoImage.classList.remove("alert-present");
    }
    if (infoImageHome) {
      enabled
        ? infoImageHome.classList.add("alert-present")
        : infoImageHome.classList.remove("alert-present");
    }
    if (mainContent) {
      enabled
        ? mainContent.classList.add("alert-present")
        : mainContent.classList.remove("alert-present");
    }
  };

  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  getModalFooter = (breakpoint) => {
    return (
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={"Submit"}
        buttonActive1={true}
        buttonActive2={true}
        module="account"
        //buttonFunction1={()}
        size={this.getSize(breakpoint)}
      />
    );
  };

  toggleModal = () => {
    const { showModal } = this.state;
    const newShowModal = !showModal;
    this.setState({ showModal: newShowModal });
  };

  closeAlert = () => {
    sessionStorage.setItem("showAlert", false);
    this.setState({ enabled: false });
  };

  render() {
    const { showModal, title, enabled, alerts } = this.state;
    const { breakpoint } = this.props;

    return (
      <div className="alert-banner-wrapper">
        {enabled && (
          <div className="cancel-button-alert" onClick={this.closeAlert}>
            <img
              src={closeButton}
              onMouseOver={(e) => (e.target.src = closeHover)}
              onMouseOut={(e) => (e.target.src = closeButton)}
            />
          </div>
        )}
        {enabled && (
          <div
            id="alert-banner-container"
            className="alert-banner-container"
            onClick={this.toggleModal}
          >
            <div className="alert-text-wrapper">
              <div className="alert-text heading60">{title}</div>
              <div className="exclamation">!</div>
            </div>
            <PortraitModalComponent
              closeModal={this.toggleModal}
              show={showModal}
              header={
                <ModalHeader
                  image={this.companyApi.getCompanyAvatar()}
                  text={""}
                />
              }
              subTitle={"Here you will see any alerts for our services "}
              title="Alerts"
              size={this.getSize(breakpoint)}
              breakpoint={breakpoint}
            >
              <AlertModalBody breakpoint={breakpoint} alerts={alerts} />
              {this.getModalFooter(breakpoint)}
            </PortraitModalComponent>
          </div>
        )}
      </div>
    );
  }
}

export default AlertBanner;
